import { useState, useEffect, Fragment } from "react";
import { Backdrop, Button, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { copyUserLink, copyNicheLink } from "utils/share";
import { setServerResponse } from "store/application/application-action";
import { isAuthenticated } from "services/Auth";
import { routes } from "routes";
import classes from "./Styles.module.css";
import edit_icon from "../../components/icons/edit_icon.svg";
import share_icon from "../../components/icons/share_icon_red.svg";
import manage_icon from "../../components/icons/manage_icon.svg";
import colors from "../../theme/themeConstants";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  userName?: string;
  myself?: boolean;
  nicheName?: string;
}

const ProfileMenuPopup = (props: IProps) => {
  const { isOpen, togglePopup, userName, myself, nicheName } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(false);
  const isAllowManage = myself && isAuth;

  useEffect(() => {
    (async () => {
      setIsAuth(await isAuthenticated());
    })();
  });

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    handleStopPropagation(event);
    togglePopup();
  };

  const handleCopy = async () => {
    if (userName) {
      await copyUserLink(userName);
    }

    if (nicheName) {
      await copyNicheLink(nicheName);
    }

    dispatch(setServerResponse("Link copied!"));
    togglePopup();
  };

  const handleManage = () => {
    navigate(routes.manageProfile());
  };

  const handleEdit = () => {
    navigate(routes.accountSettings());
  };

  const ACTIONS = [
    ...(isAllowManage ? [{ text: "Edit", icon: edit_icon, onClick: handleEdit }] : []),
    { text: "Share", icon: share_icon, onClick: handleCopy },
    ...(isAllowManage ? [{ text: "Manage", icon: manage_icon, onClick: handleManage }] : [])
  ];

  return (
    <Fragment>
      <Backdrop
        open={isOpen}
        sx={{
          zIndex: "var(--popupZ)"
        }}
        onClick={handleClose}
        id={"popupOpen"}
      >
        <Paper
          onClick={handleStopPropagation}
          sx={{
            width: "100%",
            height: "auto",
            position: "fixed",
            bottom: isOpen ? "0" : "-15rem",
            transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
            margin: "0 1rem",
            borderTopRightRadius: "24px",
            borderTopLeftRadius: "24px",
            padding: "2rem 1rem",
            paddingTop: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <div
            className={classes.handler}
            onClick={togglePopup}
          />
          <div className={classes.actions}>
            {ACTIONS.map(el => (
              <Button
                key={el.text}
                className={classes.actionButton}
                sx={{
                  backgroundColor: colors.lightGrayPaperBackground,
                  color: colors.textDark
                }}
                onClick={el.onClick}
              >
                <img src={el.icon} alt={el.text}/>
                <span>{el.text}</span>
              </Button>
            ))}
          </div>
        </Paper>
      </Backdrop>
    </Fragment>
  );
};

export default ProfileMenuPopup;
